import api from "../api/client";

const acompanhamentoApi = {
  /* Lista paginada por cursor da tela de acompanhamento — GET /v1/acompanhamento/fretes */
  listarFretes(params) {
    return api.get("/v1/acompanhamento/fretes", { params });
  },

  /* Um frete, com motorista e placa resolvidos — GET /v1/acompanhamento/fretes/:id */
  buscarFrete(idFreight) {
    return api.get(`/v1/acompanhamento/fretes/${idFreight}`);
  },

  /* Uma linha por frete com o tempo medido — GET /v1/acompanhamento/relatorios/fretes */
  listarRelatorio(params) {
    return api.get("/v1/acompanhamento/relatorios/fretes", { params });
  },

  /* Linha do tempo de um frete — GET /v1/acompanhamento/relatorios/fretes/:id */
  relatorioDoFrete(idFreight, params) {
    return api.get(`/v1/acompanhamento/relatorios/fretes/${idFreight}`, {
      params,
    });
  },

  /* Trajeto percorrido, já resumido — GET /v1/acompanhamento/fretes/:id/trajeto */
  buscarTrajeto(idFreight, params) {
    return api.get(`/v1/acompanhamento/fretes/${idFreight}/trajeto`, {
      params,
    });
  },
};

export default acompanhamentoApi;
